export default "__VITE_ASSET__D$ZKX9Ua__"